// 引入语言包
import zhCN from './locales/zh-CN.json'
import en from './locales/en.json'

export default {
    // 设置默认语言
    locale: localStorage.getItem('lang') || 'en',
    // 当找不到对应语言时使用的备用语言
    fallbackLocale: 'en',
    // 语言包
    messages: {
        'zh-CN': zhCN,
        'en': en,
    },
    // 抑制警告
    silentFallbackWarn: true
}